<mat-card><div
  class="container" fxLayout="column" fxLayoutAlign="start center" >
  <div><mat-icon>schedule</mat-icon></div>
  <div><h1>Bíðum svara: {{this.count}}</h1></div>
</div></mat-card>
